<p-toast [ngClass]="{ 'mobile-toast': isMobile }"></p-toast>

<div class="session-inactive-banner" *ngIf="sessionInactive && !bannerDismissed" role="alert">
  <span class="session-inactive-banner__text">Session Inactive. Please close this tab.</span>
  <button type="button" class="session-inactive-banner__close" aria-label="Close" (click)="dismissBanner()">
    &times;
  </button>
</div>

<div class="app-outlet">
  <router-outlet></router-outlet>
</div>

<div class="session-inactive-overlay" *ngIf="sessionInactive" (click)="onBlockedClick()"></div>

<div class="session-closed-page" *ngIf="sessionClosed" role="alert">
  <p class="session-closed-page__message">Cannot refresh inactive session. Please close this tab.</p>
</div>
